import React, { useEffect } from 'react'

const Category = () => {
    useEffect(() => {
        document.title="1Tostão | Categorias"
    })

    return (
        <div>
            Category
        </div>
    );
}
 
export default Category;